import { render } from "./format-form.vue?vue&type=template&id=a976a01e&scoped=true"
import script from "./format-form.vue?vue&type=script&lang=js"
export * from "./format-form.vue?vue&type=script&lang=js"

import "./format-form.vue?vue&type=style&index=0&id=a976a01e&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a976a01e"]])

export default __exports__